export const FETCH_B2B_INVOICES_START = "FETCH_B2B_INVOICES_START";
export const FETCH_B2B_INVOICES_SUCCESS = "FETCH_B2B_INVOICES_SUCCESS";
export const FETCH_B2B_INVOICES_FAIL = "FETCH_B2B_INVOICES_FAIL";

export const FETCH_B2B_INVOICE_DETAIL_START = "FETCH_B2B_INVOICE_DETAIL_START";
export const FETCH_B2B_INVOICE_DETAIL_SUCCESS = "FETCH_B2B_INVOICE_DETAIL_SUCCESS";
export const FETCH_B2B_INVOICE_DETAIL_FAIL = "FETCH_B2B_INVOICE_DETAIL_FAIL";

export const SET_B2B_SEARCH_TEXT = "SET_B2B_SEARCH_TEXT";
export const SET_B2B_STATUSES = "SET_B2B_STATUSES";
export const SET_B2B_CURRENT_PAGE = "SET_B2B_CURRENT_PAGE";
export const SET_B2B_PAGE_SIZE = "SET_B2B_PAGE_SIZE";

export const RESET_B2B_PORTAL = "RESET_B2B_PORTAL";
